// Apollo Setup
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client/core';
import VueGoogleMaps from '@fawmi/vue-google-maps';
import { ApolloClients } from '@vue/apollo-composable';
import { createBootstrap } from 'bootstrap-vue-next';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import { createApp, h, provide } from 'vue';
import Vue3ColorPicker from 'vue3-colorpicker';

import 'vue3-colorpicker/style.css';

import { createI18n } from 'vue-i18n';

import 'vue-multiselect/dist/vue-multiselect.css';

import App from './App.vue';

import './assets/images/fasted-marker-grey.png';
import './assets/images/fasted-marker.png';
import './assets/images/favicon.ico';

import { createPinia } from 'pinia';

import Acl from 'lib/acl-directive';
import { useFastedApi } from 'lib/fasted_api';
import router from 'lib/routes';

import de from './i18n/de/de.json';
import en from './i18n/en/en.json';
import es from './i18n/es/es.json';
import ja from './i18n/ja/ja.json';
import pt from './i18n/pt/pt.json';

const pinia = createPinia();

const language = (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language || window.navigator.userLanguage || window.navigator.browserLanguage;

const backendHost = process.env.BACKEND_HOST;

const httpLink = new HttpLink({
  uri: [backendHost, 'graphql'].join('/'),
  includeUnusedVariables: true,
});

const authLink = new ApolloLink(async (operation, forward) => {
  operation.setContext({
    headers: await useFastedApi().getHeaders(operation),
  });
  return forward(operation);
});

const cache = new InMemoryCache();

// Create the apollo client
const authClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
  connectToDevTools: process.env.NODE_ENV !== 'production',
});

// Non auth apollo client
const nonAuthApolloClient = new ApolloClient({
  link: httpLink,
  cache,
  connectToDevTools: process.env.NODE_ENV !== 'production',
});

// Locale settings
const messages = {
  de,
  en,
  es,
  ja,
  pt,
};

const simplifiedLocale = language?.split('-', 1)?.at(0);
const supportedCurrentLocale = Object.keys(language).includes(simplifiedLocale) ? simplifiedLocale : 'en';

const i18n = createI18n({
  legacy: false,
  locale: supportedCurrentLocale,
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true,
});

const app = createApp({
  setup() {
    provide(ApolloClients, { default: authClient, nonAuthApolloClient });
  },
  render: () => h(App),
});

app.config.globalProperties.root = backendHost;

app.config.globalProperties.$locale = {
  change(lang) {
    i18n.locale = lang;
  },
  current() {
    return i18n.locale;
  },
};

app.directive('acl', Acl);

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(createBootstrap());
app.use(Vue3ColorPicker);

app.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC6jtthSBALiGFpVj9Gw-qgcoT_RcVHqZA',
    libraries: 'places',
    v: 'quarterly',
  },
});

app.mount('#app');
